import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';

import { ModalService, ClosableModal } from '../../../shared/modules/modal';

import {
  ComparabilityStatus,
  TransactionComparability,
  ComparabilityModalPayload
} from '../../../shared/models';
import { TinyTextEditor, TranslationConstants } from '../../../shared/constants';

import { TransactionsComparabilityService } from '../../../shared/services';

@Component({
  selector: 'determine-acceptance-modal',
  templateUrl: './determine-acceptance-modal.component.html',
})
export class DetermineAcceptanceModalComponent extends ClosableModal implements OnInit, OnDestroy {
  data: ComparabilityModalPayload;
  comparability = new TransactionComparability();
  comparabilityStatuses: ComparabilityStatus[] = [];

  tinyInit = TinyTextEditor.INIT;

  private subscriptions: Subscription[] = [];

  constructor(
    protected modalService: ModalService,
    private _comparabilityService: TransactionsComparabilityService
  ) {
    super(modalService);
    this.confirmationModalTitle = TranslationConstants.DETERMINE_ACCEPTANCE_CLOSE_TITLE;
  }

  ngOnInit(): void {
    this.getComparability();
    this.getStatuses();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => { subscription.unsubscribe(); });
  }

  save(): void {
    if (this.isSaveDisabled) {
      return;
    }

    this.isSaveDisabled = true;

    this._comparabilityService.editTransactionAcceptance(this.comparability)
      .subscribe(() => {
        this.closeAllModals();
        this.success();
      });
  }

  markFormAsTouched(form: NgForm): void {
    form.form.markAsTouched();
  }

  private getComparability(): void {
    this._comparabilityService.show(this.data.transactionComparabilityId).subscribe((res) => {
      this.comparability = res.result.transactionComparability;
    });
  }

  private getStatuses(): void {
    this._comparabilityService.getTransactionComparabilityStatuses().subscribe((res) => {
      this.comparabilityStatuses = res.result.comparabilityStatuses;
    });
  }
}
